<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <radio-question [data]="haveMeters.data" [valueSelected]="haveMeters.valueSelected"
                    (selectAnswer)="onHaveMetersSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <radio-question [data]="cancelUphold.data" [active]="haveMeters.valueSelected === 'y'"
                    [valueSelected]="cancelUphold.valueSelected"
                    (selectAnswer)="onCancelUpholdSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">3</i>
    <radio-question [data]="meterMethod.data" [active]="haveMeters.valueSelected === 'y'"
                    [valueSelected]="meterMethod.valueSelected"
                    (selectAnswer)="onMeterMethodSelected($event)"></radio-question>
    <br />
    <div class="default-text" [innerHTML]="textCopy.complaintDaysTitle"></div>
    <input aria-label=""  class="app-input policy-input" type="text" [(ngModel)]="complaintDays"
           [disabled]="haveMeters.valueSelected === 'n' || meterMethod.valueSelected !== '0'" />
  </div>

  <div class="policy-item">
    <i class="policy-number">4</i>
    <div class="default-text large" [innerHTML]="textCopy.faultyMeterTitle"></div>
    <div class="default-text" [innerHTML]="textCopy.faultyMeterSubtitle"></div>
    <input aria-label=""  class="app-input policy-input" type="text" [(ngModel)]="faultyMeter"
           [disabled]="haveMeters.valueSelected !== 'y'" />
    <br />
    <radio-question [data]="faultyMeterPolicy.data" [active]="haveMeters.valueSelected === 'y'"
                    [valueSelected]="faultyMeterPolicy.valueSelected"
                    (selectAnswer)="onFaultyMeterPolicySelected($event)"></radio-question>
    <br />
    <div class="default-text" [innerHTML]="textCopy.fewDaysTitle"></div>
    <input aria-label=""  class="app-input policy-input" type="text" [(ngModel)]="fewDays"
           [disabled]="haveMeters.valueSelected !== 'y' || faultyMeterPolicy.valueSelected === '0'" />
    <br />
    <radio-question [data]="acceptFaultyMeter.data" [active]="haveMeters.valueSelected === 'y'"
                    [valueSelected]="acceptFaultyMeter.valueSelected"
                    (selectAnswer)="onAcceptFaultyMeterSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">5</i>
    <radio-question [data]="refund.data" [active]="haveMeters.valueSelected === 'y'"
                    [valueSelected]="refund.valueSelected"
                    (selectAnswer)="onRefundSelected($event)"></radio-question>
    <br />
    <div class="default-text" [innerHTML]="textCopy.safeguardTitle"></div>
    <span class="default-title">&#163;</span>
    <input aria-label=""  class="app-input policy-input" type="text" [(ngModel)]="safeguard"
           [disabled]="haveMeters.valueSelected !== 'y'" />
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
